export const HERO_IMAGE = {
  x1: 'https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/hero_x1.png',
  x2: 'https://cdn.cian.site/frontend/e2e-form-assets/b2c_promo/hero_x2.png',
};
